import { makeStyles } from '@material-ui/core/styles'
import { VISIT_CARD_MOBILE_REDUCTION } from 'constants/breakpoints'

const useStyles = makeStyles((theme) => ({
  collapsedContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  intakeResultsButton: {
    marginTop: '18px',
  },
  addPsychotherapyNotesButton: {
    marginBottom: '28px',
    '& svg': {
      fill: '#FFFFFF !important',
    },
  },
  photos: {
    marginTop: '20px',
  },
  horizontalRowsContainer: {
    '& > div': {
      width: 'initial',
      flexWrap: 'wrap',
      '& > div': {
        marginRight: theme.spacing(5.5),
        justifyContent: 'initial',
        marginBottom: theme.spacing(1.5),
        [theme.breakpoints.down(VISIT_CARD_MOBILE_REDUCTION)]: {
          marginRight: theme.spacing(2),
        },
        [theme.breakpoints.down(410)]: {
          marginRight: theme.spacing(1),
        },
      },
    },
  },
  icdList: {
    marginLeft: '25px',
    marginTop: '-8px',
    marginBottom: '8px',
  },
}))

export default useStyles
